/*
 * PVJ - cart drawer
 *
 * Two jobs, both filling gaps in what theme.js does for this drawer.
 */
(function () {
  'use strict';

  /*
   * 1. Focus.
   *
   * theme.js only traps focus in the cart drawer once an animationend fires on
   * [data-cart-drawer-inner] (see openCartDrawer). assets/pvj-cart-drawer.css
   * gives it an animation to fire, but that is a single point of failure for
   * something important: the drawer's own Escape-to-close listener is bound to
   * the drawer element, so if focus is still out on the page behind it, Escape
   * never reaches it. Any setup where that animation does not run - a
   * backgrounded tab, a future reduced-motion rule - would silently cost the
   * keyboard user their way out.
   *
   * So put focus on the close button as soon as the drawer opens, the way the
   * pickup drawer does it synchronously in show(). theme.js still runs its own
   * trapFocus afterwards and re-focuses the same button, which is harmless;
   * this only guarantees the drawer is never left unfocused.
   */
  document.addEventListener('theme:cart-drawer:open', function (event) {
    var drawer = event.detail && event.detail.target;

    if (!drawer) return;

    var closeButton = drawer.querySelector('[data-cart-drawer-close]');

    if (!closeButton) return;

    /*
     * This event is dispatched just before the is-open class lands, so the
     * panel is still visibility: hidden and cannot take focus yet. Deferring
     * to the next task puts us after that class is set.
     */
    setTimeout(function () {
      if (!drawer.classList.contains('is-open')) return;
      if (drawer.contains(document.activeElement)) return;

      closeButton.focus();
    }, 0);
  });

  /*
   * 2. The piece count at the top of the drawer.
   *
   * Liquid renders it correctly on first paint; this keeps it in step when the
   * bag changes without a reload. It cannot piggyback on the header badge's
   * [data-cart-items-count], because theme.js resolves that with a single
   * querySelector and so only ever updates the first one in the document.
   *
   * theme:cart:change carries the summed quantity, which is the same number
   * cart.item_count gives Liquid.
   *
   * Both plural forms come from the markup as data attributes so the count
   * stays translatable rather than being rebuilt in English here. 999 is a
   * stand-in the theme's t filter has already pluralised around; swapping it
   * for the real number keeps whatever wording and word order the translation
   * uses. Fine for the store's two locales (en, pt-PT), which both split
   * simply into one/other.
   */
  function renderCount(element, count) {
    if (!(count > 0)) {
      element.hidden = true;
      return;
    }

    var template = count === 1 ? element.dataset.countOne : element.dataset.countOther;

    if (template) {
      element.textContent = template.replace('999', count);
    }

    element.hidden = false;
  }

  document.addEventListener('theme:cart:change', function (event) {
    var element = document.querySelector('[data-cart-count]');

    if (!element || !event.detail) return;

    var count = parseInt(event.detail.cartCount, 10);

    if (isNaN(count)) return;

    renderCount(element, count);
  });
})();
